<template>
  <!-- 主容器，左侧内容区域 -->
  <div class="left-content">
    <!-- 品牌Logo显示区域，仅当订单存在且包含品牌配置和Logo图片时显示 -->
    <div class="brand-logo" v-if="!isMobile && isQr">
      <!-- 显示品牌Logo图片 -->
      <img class="logo" alt="brand logo" v-if="order?.brandConfig?.logoImage" :src="order?.brandConfig?.logoImage" />
      <span class="brand" v-else-if="order?.brandConfig?.brand">{{ getBrandText(order?.brandConfig?.brand) }}</span>
      <span class="brand" v-else>{{ getWebsiteText(order?.website) }}</span>
    </div>

    <!-- 订阅订单信息区域，仅当订单包含订阅信息时显示 -->
    <div v-if="order && order.subscription">
      <!-- 订阅标题，显示"订阅"文本和产品名称 -->
      <div class="amount-label" v-if="order && order.subscription.productName">{{ $t('message.checkout.subscription') }}:{{ order && order.subscription.productName }}
      </div>
      <!-- 有试用期的情况 -->
      <div v-if="order && order.subscription.trialDays">
        <!-- 试用天数信息 -->
        <div class="amount-value">{{ order.subscription.trialDays }} {{ $t(`message.checkout.D`) }} {{
          $t('message.checkout.free') }}
        </div>
        <!-- 订阅价格和频率信息 -->
        <span class="frequency-label">{{ order && formatMoneyWithCommas(order.txnAmount) }} {{ order && order.txnCurrency }} {{ formatFrequencyLabel(order.subscription.frequencyType,
          order.subscription.frequencyPoint) }}
        </span>
      </div>
      <!-- 无试用期的情况 -->
      <div v-else>
        <!-- 显示订阅金额 -->
        <div class="amount-value">{{  order && (isQr?formatMoneyWithCommasQr(order.txnAmount):formatMoneyWithCommas(order.txnAmount)) }} {{ order && order.txnCurrency }} </div>
        <!-- 显示订阅频率标签 -->
        <div class="frequency-label">{{ formatFrequencyLabel(order.subscription.frequencyType,
          order.subscription.frequencyPoint) }}</div>
      </div>
    </div>
    <!-- 非订阅订单信息区域 -->
    <div v-else>
      <!-- 金额标签，显示"金额"文本 -->
      <div class="amount-label">{{ $t('message.checkout.amount') }}</div>
      <!-- 金额值，显示货币符号和金额-  -->
      <div class="amount-value" style="margin-bottom: 24px;" @click="copyString(order.txnAmount)">{{ order && (isQr?formatMoneyWithCommasQr(order.txnAmount):formatMoneyWithCommas(order.txnAmount)) }} {{ order && order.txnCurrency }}
        <el-button class="button" type="text" @click="copyTicket" v-if="isQr">
              <span class="iconfont icon-rongqi"></span>
            </el-button>
      </div>
    </div>
    <!-- 分隔线，用于分隔不同区域 -->
    <hr class="divider-line"  v-if="order && (order.brandConfig?.viewTxnId !== false) || order && order.website && !order.hideWebsite"/>
    <div class="order-details-container" v-if="order && (order.brandConfig?.viewTxnId !== false) || order && order.website && !order.hideWebsite">
      <!-- 订单摘要标签 -->
      <div class="order-details-label">{{ $t('message.checkout.summary') }}</div>
      <!-- 订单详情容器，始终显示 -->
      <div class="order-details-container">
        <!-- 订单号行，只有当viewTxnId不为false时才显示 -->
        <div class="order-details-row" v-if="order && (order.brandConfig?.viewTxnId !== false)">
          <!-- 订单号标题 -->
          <span class="order-details-title">{{ $t('message.checkout.orderno') }}</span>
          <!-- 订单号值 -->
          <span class="order-details-value">{{ order && order.merchantTxnId }}</span>
        </div>
        <!-- 网站信息行，只有当订单存在网站信息且不隐藏网站信息时才显示 -->
        <div class="order-details-row" v-if="order && order.website && !order.hideWebsite">
          <!-- 网站标题 -->
          <span class="order-details-title">{{ $t('message.checkout.website') }}</span>
          <!-- 网站值 -->
          <span class="order-details-value">{{ order && order.website }}</span>
        </div>
      </div>
      <!-- 底部分隔线 -->
      <hr class="divider-line" style="margin-top: 24px;" />
    </div>
  </div>
</template>

<script>
import { formatFrequencyLabel, formatMoneyWithCommas, formatMoneyWithCommasQr } from '@/utils/tools/format';
import { copyString } from '@/utils/tools/utils';
// 导入订阅频率格式化工具函数
import { subCharByLength } from '@/utils/tools/utils';
// 导出组件对象
export default {
  // 组件名称
  name: 'OrderInfo',
  // 组件接收的属性定义
  props: {
    // order属性：包含订单的所有信息
    order: {
      // 类型为对象
      type: Object,
      // 默认值为空对象
      default: () => ({}),
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    // 是否是印尼 印尼准话
    isQr: {
      type: Boolean,
      default: false,
    },
  },
  // 组件方法
  methods: {
    // 使用导入的订阅频率格式化函数
    formatFrequencyLabel,
    formatMoneyWithCommas,
    formatMoneyWithCommasQr,
    getBrandText(brand) {
      return subCharByLength(brand, 30);
    },
    getWebsiteText(website) {
      if (!website) {
        return '';
      }
      let w = website.replace('https://', '').replace('http://', '');
      if (w.startsWith('www.')) {
        w = w.replace('www.', '');
      }
      return subCharByLength(w, 30);
    },
    copyTicket() {
      copyString(this.order.txnAmount);
    },
  },
};
</script>

<style lang="scss" scoped>
// 左侧内容容器样式
.left-content {
  // 宽度100%
  width: 100%;
  // 最大宽度420像素
  max-width: 366px;
  // 使用flex布局，纵向排列
  display: flex;
  // 子元素纵向排列
  flex-direction: column;
  // 子元素左对齐
  align-items: flex-start;
  text-align: left;
}

// 品牌Logo容器样式
.brand-logo {
  // 宽度366像素
  width: auto;
  // 高度50像素
  max-height: 50px;
  // 底部外边距24像素
  margin-bottom: 24px;
  // 内容左对齐
  text-align: left;
  color: rgba(102, 112, 133, 1);
}

// 品牌Logo图片样式
.brand-logo img {
  // 高度50像素
  height: 50px;
  // 宽度自动
  width: auto;
}

// 金额标签样式
.amount-label {
  // 字体为Open Sans regular
  font-family: Open Sans regular;
  // 字重为400（常规）
  font-weight: 400;
  // 字体大小14像素
  font-size: 14px;
  // 行高14像素
  line-height: 18px;
  // 字间距0
  letter-spacing: 0px;
  // 文字颜色为灰色
  color: #667085;
  // 底部外边距16像素
  margin-bottom: 16px;
  word-break: break-word;
}

// 金额值样式
.amount-value {
  // 字体为Open Sans regular
  font-family: Open Sans bold;
  // 字重为700（粗体）
  font-weight: 700;
  // 字体大小36像素
  font-size: 36px;
  // 行高40像素
  line-height: 40px;
  // 字间距0
  letter-spacing: 0px;
  // 文字颜色为深灰色
  color: #1A202C;
  margin-bottom: 16px;
}

// 试用天数样式
.trial-days {
  // 字体为Open Sans regular
  font-family: Open Sans regular;
  // 字重为400（常规）
  font-weight: 400;
  // 字体大小14像素
  font-size: 14px;
  // 文字颜色为灰色
  color: #667085;
  // 底部外边距8像素
  margin-bottom: 8px;
}

// 订阅频率标签样式
.frequency-label {
  // 字体为Open Sans regular
  font-family: Open Sans regular;
  // 字重为400（常规）
  font-weight: 400;
  // 字体大小14像素
  font-size: 14px;
  // 文字颜色为灰色
  color: #667085;
  // 显示为块级元素
  display: block;
  // 顶部外边距4像素
  // margin-top: 4px;
  margin-bottom: 24px;
}

// 分隔线样式
.divider-line {
  // 宽度100%
  width: 100%;
  // 无边框
  border: none;
  // 顶部边框为0.5像素实线浅灰色
  border-top: 0.5px solid #C9CDD4;
  // 上下外边距各24像素
  margin: 0 0 24px 0;
}

// 订单详情容器样式
.order-details-container {
  // 宽度100%
  width: 100%;
}

// 订单详情标签样式
.order-details-label {
  // 字体为Open Sans regular
  font-family: Open Sans regular;
  // 字重为400（常规）
  font-weight: 400;
  // 字体大小14像素
  font-size: 14px;
  // 行高18像素
  line-height: 18px;
  // 字间距0
  letter-spacing: 0px;
  // 文字颜色为灰色
  color: #667085;
  // 底部外边距16像素
  margin-bottom: 16px;
}

// 订单详情行样式
.order-details-row {
  // 使用flex布局
  display: flex;
  // 子元素两端对齐
  justify-content: space-between;
  // 宽度100%
  width: 100%;
  // 字体大小14像素
  font-size: 14px;
  // 文字颜色为深灰色
  color: #23272e;
  // 底部外边距8像素
  margin-bottom: 8px;
  // 字体为Open Sans regular regular
  font-family: Open Sans regular;
  // 字重为400（常规）
  font-weight: 400;
  // 行高18像素
  line-height: 18px;
  // 字间距0
  letter-spacing: 0px;
}

// 对除最后一行外的所有订单详情行应用样式
.order-details-row:not(:last-child) {
  // 底部外边距16像素
  margin-bottom: 16px;
}

// 订单详情标题样式
.order-details-title {
  // 文字颜色为深灰色
  color: #1A202C;
}

// 订单详情值样式
.order-details-value {
  font-family: Open Sans regular;
  // 文字颜色为深灰色
  // color: #23272e;
  color: rgba(26, 32, 44, 1);
  // 单词断行
  word-break: break-all;
  // 最大宽度203像素
  max-width: 203px;
  // 文本右对齐
  text-align: right;
}

.brand {
  color: #1A202C;
}
</style>
